module.exports = __webpack_public_path__ + "static/pluginYes-779d8e0af43fc13f5614f8966a6e5cd7.png";